import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../components/utils/Input';
import Content from '../components/layout/Content';
import Switch from '../components/utils/Switch';
import Loader from '../components/utils/Loader';
import { fetchSettings, setEditedSettings, updateSettings } from '../action/app';
import { isEqual } from 'lodash';
import ErrorContainer from '../components/utils/ErrorContainer';
import { roleId } from '../constants/app';
import { setUIvisible } from '../action/UImobile';
import DateInput from '../components/utils/DateInput';
import { TimeInput } from '../components/utils/TimeInput';
import moment from 'moment';
import Select from 'react-select';
import { fetchArticlesCash, fetchArticlesCashCategories, fetchArticlesExpenditures, fetchFilials, fetchTags } from '../action/handbook';

const auths = ['sms', 'phoneInside', 'phoneOutside', 'telegram'];

const authsTitle = {
    sms: 'СМС',
    phoneInside: 'Входящий звонок',
    phoneOutside: 'Исходящий звонок',
    telegram: 'Telegram'
};

const fieldsTime = ['days', 'months'];

const fieldsTimeTitle = {
    days: 'День',
    months: 'Месяц'
}

const rangeDate = {
    'month-1': '1 месяц',
    'month-2': '2 месяца',
    'month-3': '3 месяца'
};

const zoneModeData = {
    'execute': 'Отправить в филиал Сайт',
    'abort': 'Не создавать заказ',
};

const effects = [
    { value: null, label: 'Выкл.'},
    { value: 'snow', label: 'Новый год'},
    { value: 'love', label: 'День святого Валентина'}
]

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const utcOffset = moment().utcOffset() / 60

class Settings extends Component {
    state = {
        sale: false,
        persent: false
    }

    componentDidMount() {
        this.props.fetchSettings();
        this.props.fetchArticlesCashCategories();
        this.props.fetchArticlesCash();
        this.props.fetchArticlesExpenditures();
        this.props.fetchFilials();
        this.props.fetchTags();
        this.props.setUIvisible(false, false);
    }

    onChangeSettings = (field) => (value) => {
        this.props.setEditedSettings(field, value);
    }

    onChangeAuths = (field) => (value) => {
        this.props.setEditedSettings(field, value ? value.join(' ') : '');
    }

    onChangeAuth = (field) => (value) => {
        this.props.setEditedSettings(field, value);
    }

    onChangeBonusSettings = (field) => (value) => {
        const { edited } = this.props.settings;
        const updated = {...edited.bonusConfigs};
        updated[field] = value;

        this.props.setEditedSettings('bonusConfigs', updated);
    }

    onChangeRestoreSettings = (field) => (value) => {
        const { edited } = this.props.settings;
        const updated = {...edited.restore} || {};
        updated[field] = value;
        this.props.setEditedSettings('restore', updated);
    }

    onChangeCategoriesSettings = (field) => (value) => {
        const { edited } = this.props.settings;
        const categories = edited.categories || {};
        const updated = {...categories};
        updated[field] = value;

        this.props.setEditedSettings('categories', updated);
    }

    onChangeArticlesCash = (field) => (e) => {
        const { edited } = this.props.settings;
        const articlesCash = edited.articlesCash || {};
        const updated = {...articlesCash};
        updated[field] = e.value;

        this.props.setEditedSettings('articlesCash', updated);
    }

    onChangeEffectsSettings = () => (value) => {
        const { edited } = this.props.settings;
        let updated = null;
        if(edited.effects)
            updated = {...edited.effects};
        updated = value;
        this.props.setEditedSettings('effects', updated);
    }

    onChangeFiscalSettings = (field) => (value) => {
        const { edited } = this.props.settings;
        const postItemsFiscal = edited.postItemsFiscal || {};
        const updated = {...postItemsFiscal};
        updated[field] = value;
        this.props.setEditedSettings('postItemsFiscal', updated);
    }

    onSubmit = (e) => {
        e.preventDefault();
        const payload = { ...this.props.settings.edited };
        const parsedInterval = parseInt(payload.autoRefreshInterval, 10);

        if (payload.autoRefreshInterval === '' || Number.isNaN(parsedInterval)) {
            payload.autoRefreshInterval = 30;
        } else {
            payload.autoRefreshInterval = Math.max(1, parsedInterval);
        }

        this.props.updateSettings(payload);
    }

    isValidSale() {
        const { edited, init } = this.props.settings;
        
        let result = true;

        if (isEqual(edited, init)) {
            result = false;
        }

        if (!edited.saleFirstOrderValue) result = false;
        if (!edited.categories) return false;
        if (!edited.categories.pizza || !edited.categories.wok || !edited.categories.mainWok || !edited.categories.souceWok || !edited.categories.meatWok || !edited.categories.toppingWok) return false;
        if (edited.bonusConfigs.level1Active && !edited.bonusConfigs.level1Value) return false;
        if (edited.bonusConfigs.level2Active && !edited.bonusConfigs.level2Value) return false;
        if (edited.bonusConfigs.level3Active && !edited.bonusConfigs.level3Value) return false;
        if (!edited.bonusOrderPersent || edited.bonusOrderPersent < 10 || edited.bonusOrderPersent > 100) return false;

        return result;
    }

    onChangeTime = (field) => (date) => {
        const newDate = moment.utc(date).add({ hours: utcOffset });
        this.onChangeSettings(field)(newDate)
    }

    renderAdress = (item) => {
        if (!item) return 'Не определен';
        return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
    };

    renderTag = (tag) => {
        if (tag === 0) return {
            value: 0,
            label: 'Автораспределение (hardcode)',
        };

        if (!tag) return {
            value: null,
            label: 'Не определен',
        };

        return {
            value: tag.id ? tag.id : null,
            label: tag.name ? tag.name : 'Не определен',
        };
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Настройки</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button disabled={!this.isValidSale()} onClick={this.onSubmit} className="btn btn-primary">Сохранить настройки</button>
                </div>
            </div>
            </div>
        );
    }

    renderSale() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Скидка на первый заказ
                        </h3>
                    </div>

                    <div className="kt-portlet__head-toolbar">
                        <div style={{ marginTop: '13px' }}>
                            <Switch onChange={(value) => this.onChangeSettings('saleFirstOrderActive')(value)} checked={edited.saleFirstOrderActive}/>
                        </div>
                    </div>
                    
                </div>
            
                
                    <div className="kt-portlet__body">
                        <Input 
                            label="Размер скидки"
                            value={edited.saleFirstOrderValue}
                            onChange={(e) => this.onChangeSettings('saleFirstOrderValue')(+e.target.value)}
                            type="number"
                        />
                        <div className="form-group row">
                            
                            <label className="col-9 col-form-label">Процент</label>
                            <div className="col-3">
                                <Switch onChange={(value) => this.onChangeSettings('saleFirstPersent')(value)} checked={edited.saleFirstPersent}/>
                            </div>
                        </div>
                        
                    </div>
                    
               	
            </div>
                        
        );
    }

    renderSettingsFiscal() {
        const { edited } = this.props.settings;

        return(
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройки фискальных чеков
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <Input 
                        label="Текст перед QR кодом"
                        value={edited.postItemsFiscal && edited.postItemsFiscal.firstText ? edited.postItemsFiscal.firstText : null}
                        onChange={(e) => this.onChangeFiscalSettings('firstText')(e.target.value)}
                        type="string"
                    />
                    <Input 
                        label="Ссылка для QR кода"
                        value={edited.postItemsFiscal && edited.postItemsFiscal.qr ? edited.postItemsFiscal.qr : null}
                        onChange={(e) => this.onChangeFiscalSettings('qr')(e.target.value)}
                        type="string"
                    />
                    <Input 
                        label="Текст после QR кодом"
                        value={edited.postItemsFiscal && edited.postItemsFiscal.secondText ? edited.postItemsFiscal.secondText : null}
                        onChange={(e) => this.onChangeFiscalSettings('secondText')(e.target.value)}
                        type="string"
                    />
                </div>
            </div>
        );
    }

    renderVersion() {
        const { edited } = this.props.settings;
  
        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Уведомление обновления приложения
                        </h3>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <div style={{ marginTop: '13px' }}>
                            <Switch onChange={(value) => this.onChangeSettings('showVersion')(value)} checked={edited.showVersion}/>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <Input 
                        label="Текущая версия приложения"
                        value={edited.version}
                        onChange={(e) => this.onChangeSettings('version')(e.target.value)}
                    />
                </div>
            </div>                       
            );
    }

    renderFrontpad() {
        const { edited } = this.props.settings;
        return (
            <>
                { this.props.currentUser.role.id === 4 && (
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Отправление в FrontPad
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('isEnableFrontpad')(value)} checked={edited.isEnableFrontpad}/>
                            </div>
                        </div>
                    </div>
                </div>   
                )}                        
            </>
        );
    }

    renderValidateOrders() {
        const { edited } = this.props.settings;
        return (
            <>
                { this.props.currentUser.role.id === 4 && (
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Валидация заказов
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('validateOrders')(value)} checked={edited.validateOrders}/>
                            </div>
                        </div>
                    </div>
                </div>   
                )}                        
            </>
        );
    }

    renderPointsLogs() {
        const { edited } = this.props.settings;

        return (
            <>
                { this.props.currentUser.role.id === roleId.admin && (
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Логирование работы филиалов
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('pointsLogs')(value)} checked={edited.pointsLogs}/>
                            </div>
                        </div>
                    </div>
                </div>   
                )}                        
            </>
        );
    }

    renderOrderGoodsLogs() {
        const { edited } = this.props.settings;

        return (
            <>
                { this.props.currentUser.role.id === roleId.admin && (
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Логирование товаров в заказе
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('isEnableOrderGoodsLogs')(value)} checked={edited.isEnableOrderGoodsLogs}/>
                            </div>
                        </div>
                    </div>
                </div>   
                )}                        
            </>
        );
    }

    renderBlockedPhones() {
        const { edited } = this.props.settings;

        return (
            <>
                { this.props.currentUser.role.id === roleId.admin && (
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Заблокировать номера из чёрного списка
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('isEnableBlockedPhones')(value)} checked={edited.isEnableBlockedPhones}/>
                            </div>
                        </div>
                    </div>
                </div>   
                )}                        
            </>
        );
    }

    renderIntegration() {
        const { edited } = this.props.settings;

        return (
            <>
                {this.props.currentUser.role.id === roleId.admin && (
                <>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Интеграция ЯЕ
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('integrationYE')(value)} checked={edited.integrationYE}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Интеграция Купер
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('integrationKuper')(value)} checked={edited.integrationKuper}/>
                            </div>
                        </div>
                    </div>                    
                </div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Списание сырья
                            </h3>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div style={{ marginTop: '13px' }}>
                                <Switch onChange={(value) => this.onChangeSettings('enableConsumption')(value)} checked={edited.enableConsumption}/>
                            </div>
                        </div>
                    </div>
                </div>
                </>
                )}
            </>
        );
    }

    renderEffectsSetting() {
        const { edited } = this.props.settings;
        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка эффектов сайта
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className='form-group'>
                        <Select 
                        value={effects.find(effect => effect.value === edited.effects) || null}
                        closeMenuOnSelect={true}
                        onChange={(e) => this.onChangeEffectsSettings('effects')(e.value)}
                        options={effects}
                        placeholder="Выбор эффекта"
                        noOptionsMessage={() => 'Нет эффектов'}
                        />
                    </div>                    
                </div>
            </div>
                        
        );
    }

    renderCart() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройки корзины
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    
                    <div className="form-group">
                    <label style={{ marginRight: '10px' }}>Дата обновления меню</label>
                    
                        <DateInput
                            placeholderText="Введите дату"
                            selected={edited.menuUpdated ? moment(edited.menuUpdated).toDate() : null}
                            onChange={this.onChangeSettings('menuUpdated')}
                            maxDate={moment().toDate()}
                        />
                    </div>
                    
                    <Input 
                        label="Описание вока"
                        value={edited.wokDescr}
                        onChange={(e) => this.onChangeSettings('wokDescr')(e.target.value)}
                    />

                    <div className="form-group row">
                        <label className="col-9 col-form-label">Промоакции</label>
                        <div className="col-3">
                            <Switch onChange={(value) => this.onChangeSettings('promotions')(value)} checked={edited.promotions}/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-9 col-form-label">Автопривязка акции</label>
                        <div className="col-3">
                            <Switch onChange={(value) => this.onChangeSettings('isAutoLinkPromo')(value)} checked={edited.isAutoLinkPromo}/>
                        </div>
                    </div>
                    <Input 
                        label="Автооткрытие акций (в секундах)"
                        value={edited.autoPromo}
                        onChange={(e) => this.onChangeSettings('autoPromo')(+e.target.value)}
                        type="number"
                        description="0 - выключить"
                    />
                </div>
            </div>
                        
        );
    }

    renderUrls() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройки ссылок
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <Input 
                        label='Ссылка на форму "Отзыв"'
                        value={edited.urlReviewForm}
                        onChange={(e) => this.onChangeSettings('urlReviewForm')(e.target.value)}
                    />
                    <Input 
                        label='Ссылка на форму "Франшиза"'
                        value={edited.urlFranchiseForm}
                        onChange={(e) => this.onChangeSettings('urlFranchiseForm')(e.target.value)}
                    />
                </div>
            </div>
        );
    }

    renderOrder() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка заказов
                        </h3>
                    </div>
                </div>
            
                
                    <div className="kt-portlet__body">
                    
                   
                        <div className="row" style={{ marginBottom: 10 }}>
                            <label className="col-xl-12 col-lg-12 col-md-12 col-form-label">Постоянный клиент</label>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{ display: 'flex' }}>
                                    <Input
                                        disableGroup
                                        value={edited.loyalOrderCount}
                                        onChange={(e) => this.onChangeSettings('loyalOrderCount')(+e.target.value)}
                                        type="number"
                                    />
                                    <div style={{ padding: 10, whiteSpace: 'nowrap' }}>заказов за</div>
                                    <select onChange={(e) => this.onChangeSettings('loyalRangeDate')(e.target.value)} value={edited.loyalRangeDate} className="form-control">
                                        {
                                            Object.keys(rangeDate).map((key, index) => (
                                                <option key={key} value={key}>{rangeDate[key]}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <span className="form-text text-muted" style={{ marginTop: 5 }}>0 - выключить</span>
                            </div>
                        </div>

                        <div className="kt-separator kt-separator--border-dashed kt-separator--space-md"></div>

                        <div className="form-group row">
                            <label className="col-9 col-form-label">Определение зоны доставки</label>
                            <div className="col-3">
                                <Switch onChange={(value) => this.onChangeSettings('zone')(value)} checked={edited.zone}/>
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-9 col-form-label">Определение зоны только для лояльных пользователей</label>
                            <div className="col-3">
                                <Switch onChange={(value) => this.onChangeSettings('onlyLoyal')(value)} checked={edited.onlyLoyal}/>
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-12 col-form-label">При неопределении координат адреса</label>
                            <div className="col-12">
                                <select onChange={(e) => this.onChangeSettings('zoneMode')(e.target.value)} value={edited.zoneMode} className="form-control">
                                        {
                                            Object.keys(zoneModeData).map((key, index) => (
                                                <option key={key} value={key}>{zoneModeData[key]}</option>
                                            ))
                                        }
                                    </select>
                            </div>
                        </div>

                        <div className="kt-separator kt-separator--border-dashed kt-separator--space-md"></div>

                        <div className='form-group'>
                            <label>Филиал КЦ</label>
                            <Select
                                isLoading={this.props.loadingFilials}
                                isDisabled={this.props.loadingFilials}
                                closeMenuOnSelect={true}                    
                                options={this.props.filials.map((item) => ({ value: item.id, label: this.renderAdress(item) }))}
                                onChange={(e) => this.onChangeSettings('idPointCC')(+e.value)}
                                noOptionsMessage={() => 'Нет филиалов'}
                                value={{value: edited.idPointCC, label: this.renderAdress(this.props.filials.find((item) => item.id === edited.idPointCC))}}                    
                            />
                        </div>
                        <div className='form-group'>
                            <label>Филиал Robovoice</label>
                            <Select
                                isLoading={this.props.loadingFilials}
                                isDisabled={this.props.loadingFilials}
                                closeMenuOnSelect={true}                    
                                options={this.props.filials.map(item => ({ value: item.id, label: this.renderAdress(item) }))}
                                onChange={(e) => this.onChangeSettings('idPointRobovoice')(+e.value)}
                                noOptionsMessage={() => 'Нет филиалов'}
                                value={{value: edited.idPointRobovoice, label: this.renderAdress(this.props.filials.find((item) => item.id === edited.idPointRobovoice))}}                    
                            />
                        </div>
                        <div className="kt-separator kt-separator--border-dashed kt-separator--space-md"></div>
                        <div className='form-group'>
                            <label>Отметка автораспред</label>
                            <Select
                                isLoading={this.props.loadingTags}
                                isDisabled={this.props.loadingTags}
                                closeMenuOnSelect={true}                    
                                options={[
                                { value: 0, label: 'Автораспределение (hardcode)'},
                                ...this.props.tags.sort((a, b) => {
                                if (a.name < b.name) return -1;
                                if (a.name > b.name) return 1;
                                return 0;
                                })
                                .map(item => (
                                    this.renderTag(item)
                                ))]}                                
                                onChange={(e) => this.onChangeSettings('idTagAutoDistribution')(+e.value)}
                                noOptionsMessage={() => 'Нет отметок'}
                                value={this.renderTag(edited.idTagAutoDistribution !== 0 ? this.props.tags.find((item) => item.id === edited.idTagAutoDistribution) : 0)}
                            />
                        </div>
                        <div className="kt-separator kt-separator--border-dashed kt-separator--space-md"></div>

                        <div className="form-group row">
                            <label className="col-9 col-form-label">Отправлять Email</label>
                            <div className="col-3">
                                <Switch onChange={(value) => this.onChangeSettings('sendEmail')(value)} checked={edited.sendEmail}/>
                            </div>
                        </div>
                        
                    </div>
                    
               	
            </div>
                        
        );
    }

    renderLevels() {
        const { bonusConfigs } = this.props.settings.edited;

        return (
            <tbody>
                <tr>
                    <td style={{ width: '33.3%' }}>Уровень 1 - клиент</td>
                    <td style={{ width: '33.3%' }}>
                        <div>
                            <Input 
                                disableGroup={true}
                                value={bonusConfigs.level1Value || ''}
                                onChange={(e) => this.onChangeBonusSettings('level1Value')(+e.target.value)}
                                type="number"
                            />
                        </div>
                    
                    </td>
                    <td style={{ width: '33.3%' }}>
                        <Switch nomargin={true} onChange={(value) => this.onChangeBonusSettings('level1Active')(value)} checked={bonusConfigs.level1Active}/>
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '33.3%' }}>Уровень 2 - рекомендатор клиента</td>
                    <td style={{ width: '33.3%' }}>
                        <div>
                            <Input 
                                disableGroup={true}
                                value={bonusConfigs.level2Value || ''}
                                onChange={(e) => this.onChangeBonusSettings('level2Value')(+e.target.value)}
                                type="number"
                            />
                        </div>
                    
                    </td>
                    <td style={{ width: '33.3%' }}>
                        <Switch nomargin={true} onChange={(value) => this.onChangeBonusSettings('level2Active')(value)} checked={bonusConfigs.level2Active}/>
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '33.3%' }}>Уровень 3 - рекомендатор рекомендатора клиента</td>
                    <td style={{ width: '33.3%' }}>
                        <div>
                            <Input 
                                disableGroup={true}
                                value={bonusConfigs.level3Value || ''}
                                onChange={(e) => this.onChangeBonusSettings('level3Value')(+e.target.value)}
                                type="number"
                            />
                        </div>
                    
                    </td>
                    <td style={{ width: '33.3%' }}>
                        <Switch nomargin={true} onChange={(value) => this.onChangeBonusSettings('level3Active')(value)} checked={bonusConfigs.level3Active}/>
                    </td>
                </tr>
            </tbody>
        );  
    }

    renderCashBack() {
        const { edited } = this.props.settings;
        return (
            
            <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                <div className="kt-widget11">
                    <div className="table-responsive">					 
                        <table className="table">
                            <thead>
                                <tr style={{ borderBottom: '1px solid #eff0f6' }}>
                                    <td style={{ width: '33.3%', paddingBottom: 10 }}>Уровень</td>
                                    <td style={{ width: '33.3%', paddingBottom: 10 }}>Размер скидки (% от заказа)</td>
                                    <td style={{ width: '33.3%', paddingBottom: 10 }}>Активен</td>
                                </tr>
                            </thead>
                            {this.renderLevels()}  
                        </table>
                    </div>
                    { this.props.currentUser.role.id === roleId.admin && (
                    <div className="kt-portlet">
                        <div className="kt-portlet__head">
                            <div className="kt-portlet__head-label">
                                <h3 className="kt-portlet__head-title">
                                    Логирование бонусных баллов
                                </h3>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div style={{ marginTop: '13px' }}>
                                    <Switch onChange={(value) => this.onChangeSettings('cashbackLogs')(value)} checked={edited.cashbackLogs}/>
                                </div>
                            </div>
                        </div>
                    </div>   
                    )}
                </div>
            </div>
        );
    }

    renderBonus() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Бонусная программа
                        </h3>
                    </div>

                    <div className="kt-portlet__head-toolbar">
                        <div style={{ marginTop: '13px' }}>
                            <Switch onChange={(value) => this.onChangeSettings('bonusProgramm')(value)} checked={edited.bonusProgramm}/>
                        </div>
                    </div>
                    
                </div>
            
                            <div className="kt-portlet__body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="Бонус за регистрацию"
                                            value={edited.bonusConfigs.registration}
                                            onChange={(e) => this.onChangeBonusSettings('registration')(+e.target.value)}
                                            type="number"
                                            description="0 - выключить"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input 
                                            label="Бонус за 'приведи друга'"
                                            value={edited.bonusConfigs.friend}
                                            onChange={(e) => this.onChangeBonusSettings('friend')(+e.target.value)}
                                            type="number"
                                            description="0 - выключить"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input 
                                            label="Бонус за регистрацию по промокоду"
                                            value={edited.bonusConfigs.inviter}
                                            onChange={(e) => this.onChangeBonusSettings('inviter')(+e.target.value)}
                                            type="number"
                                            description="0 - выключить"
                                        />
                                    </div>
                                 </div>
                                 <div className="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>
                                 <div className="row" style={{ marginTop: 20 }}>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="Процент от суммы заказа"
                                            value={edited.bonusOrderPersent}
                                            onChange={(e) => this.onChangeSettings('bonusOrderPersent')(+e.target.value)}
                                            type="number"
                                            description="10% - минимум, 100% - максимум"
                                        />
                                    </div>
                                    </div>
                                 <div className="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>
                                 <div style={{ display: 'flex', alignItems: 'center', fontSize: '1.2rem', fontWeight: 500, color: '#48465b', marginTop: 15, marginBottom: 25 }}>
                                    <div style={{ marginRight: 15 }} className="kt-widget__icon">
                                        <i style={{ fontSize: '2.2em', color: '#0abb87' }} className="flaticon-network"></i>
                                    </div>
                                    Кэшбэк
                                 </div>
                                 {this.renderCashBack()}
                            </div>
            
	
            </div>
        );
    }

    renderRestore() {
        const { edited } = this.props.settings;
        const restore = edited.restore || {};

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Восстановление аккаунтов
                        </h3>
                    </div>

                    <div className="kt-portlet__head-toolbar">
                        <div style={{ marginTop: '13px' }}>
                            <Switch onChange={(value) => this.onChangeRestoreSettings('active')(value)} checked={restore.active || false}/>
                        </div>
                    </div>
                </div>
            
                <div className="kt-portlet__body">
                    <div className="row">
                        <div className="col-md-4">
                            <Input
                                required={true}
                                label="Кол-во времени"
                                value={restore.time || 0}
                                onChange={(e) => this.onChangeRestoreSettings('time')(+e.target.value)}
                                type="number"
                                description="0 - моментальное восстановление"
                            />
                        </div>
                        <div className="col-md-4">
                            <div className='form-group'>
                            <label className="col-xl-12 col-lg-12 col-form-label" style={{ padding: 0, margin: 0, fontSize: '1rem', marginBottom: '0.5rem', paddingLeft: '10px' }}>Единица времени *</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={restore.fieldTime ? [restore.fieldTime] : undefined}
                                    options={fieldsTime}
                                    getOptionLabel={(item) => `${fieldsTimeTitle[item]}`}
                                    getOptionValue={(item) => item}
                                    onChange={this.onChangeRestoreSettings('fieldTime')}
                                    isClearable={false}
                                    placeholder="Выберите единицу времени..."
                                    noOptionsMessage={() => 'Нет единиц времени'}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCategories() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка категорий
                        </h3>
                    </div>
                </div>
            
                            <div className="kt-portlet__body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Пицца"
                                            value={edited.categories ? edited.categories.pizza : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('pizza')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Wok"
                                            value={edited.categories ? edited.categories.wok : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('wok')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Основа wok"
                                            value={edited.categories ? edited.categories.mainWok : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('mainWok')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Соусы wok"
                                            value={edited.categories ? edited.categories.souceWok : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('souceWok')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Мясо wok"
                                            value={edited.categories ? edited.categories.meatWok : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('meatWok')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <Input
                                            required={true}
                                            label="ID категории Топпинги wok"
                                            value={edited.categories ? edited.categories.toppingWok : ''}
                                            onChange={(e) => this.onChangeCategoriesSettings('toppingWok')(+e.target.value)}
                                            type="number"
                                        />
                                    </div>
                                 </div>
                            </div>
            
	
            </div>
        );
    }

    renderArticlesCash() {
        const { edited } = this.props.settings;
        const articlesCash = edited.articlesCash || {};
        const optionsArticles = (this.props.articlesCash || []).map((article) => ({ label: article.name, value: article.id}));
        const { paymentInvoice, paymentWages } = articlesCash;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Кассовые статьи для оплат
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Статья расхода "Оплата накладной"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={paymentInvoice ? optionsArticles.find((option) => option.value === paymentInvoice) : null}
                                    options={optionsArticles}
                                    onChange={this.onChangeArticlesCash('paymentInvoice')}
                                    isClearable={false}
                                    placeholder="Оплата накладной..."
                                    noOptionsMessage={() => 'Нет статей'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Статья расхода "Оплата выплаты"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={paymentWages ? optionsArticles.find((option) => option.value === paymentWages) : null}
                                    options={optionsArticles}
                                    onChange={this.onChangeArticlesCash('paymentWages')}
                                    isClearable={false}
                                    placeholder="Оплата выплаты..."
                                    noOptionsMessage={() => 'Нет статей'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderArticlesCashReport() {
        const { edited } = this.props.settings;
        const articlesCash = edited.articlesCash || {};
        const optionsArticles = (this.props.articlesCash || []).map((article) => ({ label: article.name, value: article.id}));
        const optionsArticlesCategories = (this.props.articlesCashCategories || []).map((article) => ({ label: article.name, value: article.id}));
        const { delivery, sale, kporogu, taxes, incasso } = articlesCash;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Кассовые статьи для отчетов
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className='row'>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Категория статей "Доставка"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={delivery ? optionsArticlesCategories.find((option) => option.value === delivery) || null : null}
                                    options={optionsArticlesCategories}
                                    onChange={this.onChangeArticlesCash('delivery')}
                                    isClearable={false}
                                    placeholder="Доставка..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Категория статей "Продажа"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={sale ? optionsArticlesCategories.find((option) => option.value === sale) || null : null}
                                    options={optionsArticlesCategories}
                                    onChange={this.onChangeArticlesCash('sale')}
                                    isClearable={false}
                                    placeholder="Продажа..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Статья "Пополнение баланса КПорогу"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={kporogu ? optionsArticles.find((option) => option.value === kporogu) || null : null}
                                    options={optionsArticles}
                                    onChange={this.onChangeArticlesCash('kporogu')}
                                    isClearable={false}
                                    placeholder="КПорогу..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Категория статей "Налоги"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={taxes ? optionsArticlesCategories.find((option) => option.value === taxes) || null : null}
                                    options={optionsArticlesCategories}
                                    onChange={this.onChangeArticlesCash('taxes')}
                                    isClearable={false}
                                    placeholder="Налоги..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Категория статей "Инкассация"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={incasso ? optionsArticlesCategories.find((option) => option.value === incasso) || null : null}
                                    options={optionsArticlesCategories}
                                    onChange={this.onChangeArticlesCash('incasso')}
                                    isClearable={false}
                                    placeholder="Инкассация..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderOtherExpenditures() {
        const { edited } = this.props.settings;
        const articlesCash = edited.articlesCash || {};
        const optionsOtherExpenditures = (this.props.articlesExpenditures || []).map((article) => ({ label: article.name, value: article.id}));
        const { otherCommissionAgg, acquiringTerminal, acquiringYookassa, banking } = articlesCash;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Расходы вне смены для отчетов
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className='row'>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Расход вне смены "Эквайринг (терминал)"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={acquiringTerminal ? optionsOtherExpenditures.find((option) => option.value === acquiringTerminal) || null : null}
                                    options={optionsOtherExpenditures}
                                    onChange={this.onChangeArticlesCash('acquiringTerminal')}
                                    isClearable={false}
                                    placeholder="Эквайринг..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Расход вне смены "Эквайринг (ЮКасса)"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={acquiringYookassa ? optionsOtherExpenditures.find((option) => option.value === acquiringYookassa) || null : null}
                                    options={optionsOtherExpenditures}
                                    onChange={this.onChangeArticlesCash('acquiringYookassa')}
                                    isClearable={false}
                                    placeholder="Эквайринг..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Расход вне смены "Прочие комиссии агрегаторов"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={otherCommissionAgg ? optionsOtherExpenditures.find((option) => option.value === otherCommissionAgg) || null : null}
                                    options={optionsOtherExpenditures}
                                    onChange={this.onChangeArticlesCash('otherCommissionAgg')}
                                    isClearable={false}
                                    placeholder="Эквайринг..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-xl-12 col-lg-12 col-form-label">Расход вне смены "Банковские услуги (РКО)"</label>
                            <div className="col-lg-12 col-xl-12">
                                <Select
                                    value={banking ? optionsOtherExpenditures.find((option) => option.value === banking) || null : null}
                                    options={optionsOtherExpenditures}
                                    onChange={this.onChangeArticlesCash('banking')}
                                    isClearable={false}
                                    placeholder="Эквайринг..."
                                    noOptionsMessage={() => 'Нет категорий'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderYumapos() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка Yumapos
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="Username ключа с онлайн оплатой"
                                value={edited.yumaposKeyOnlineUsername}
                                onChange={(e) => this.onChangeSettings('yumaposKeyOnlineUsername')(e.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="Password ключа с онлайн оплатой"
                                value={edited.yumaposKeyOnlinePassword}
                                onChange={(e) => this.onChangeSettings('yumaposKeyOnlinePassword')(e.target.value)}
                                type="text"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="Url Yumapos"
                                value={edited.yumaposUrlBase}
                                onChange={(e) => this.onChangeSettings('yumaposUrlBase')(e.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="Token WebHook OrderStatusChange"
                                value={edited.yumaposTokenWebHookOrderStatusChange}
                                onChange={(e) => this.onChangeSettings('yumaposTokenWebHookOrderStatusChange')(e.target.value)}
                                type="text"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderRobovoice() {
        const { edited, init } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка Robovoice
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <h5 style={{ color: '#000' }}>
                        Робовойс
                    </h5>
                    <div className="row" style={{ borderBottom: '1px solid #ebedf2', marginBottom: '10px' }}>
                        <div className="col-md-2">
                            <div className='form-group'>
                                <label>
                                    Активен
                                </label>
                                <div>
                                    <Switch 
                                        onChange={(value) => {
                                            this.onChangeSettings('isEnableRobovoice')(value)

                                            if (value) {
                                                this.onChangeSettings('isEnableRobovoiceCron')(value)
                                            }
                                        }} 
                                        checked={edited.isEnableRobovoice} 
                                        disabled={!init.robovoiceServiceURL && !init.robovoiceToken}/>
                                </div>
                            </div>                            
                        </div>
                        <div className="col-md-4">
                            <Input
                                required={true}
                                label="Id sip-аккаунта"
                                value={edited.robovoiceChannelId}
                                onChange={(e) => this.onChangeSettings('robovoiceChannelId')(e.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="Тип средства связи: 1 - Телефонный звонок, 2 - Телефонный звонок по SIP"
                                value={edited.robovoiceChannelType}
                                onChange={(e) => this.onChangeSettings('robovoiceChannelType')(e.target.value)}
                                type="text"
                            />
                        </div>
                    </div>
                    <h5 style={{ color: '#000' }}>
                    RecordCallFromDial
                    </h5>
                    <div className="row" style={{ borderBottom: '1px solid #ebedf2', marginBottom: '10px' }}>
                        <div className="col-md-2">        
                            <label>
                                Активен
                            </label>             
                            <div>
                                <Switch onChange={(value) => this.onChangeSettings('robovoiceRecordCallFromDial')(value)} checked={edited.robovoiceRecordCallFromDial}/>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <Input
                                required={true}
                                label="robovoiceScriptId"
                                value={edited.robovoiceScriptId}
                                onChange={(e) => this.onChangeSettings('robovoiceScriptId')(e.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="receiveRobovoiceCallStatusURL"
                                value={edited.receiveRobovoiceCallStatusURL}
                                onChange={(e) => this.onChangeSettings('receiveRobovoiceCallStatusURL')(e.target.value)}
                                type="text"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="robovoiceServiceURL"
                                value={edited.robovoiceServiceURL}
                                onChange={(e) => this.onChangeSettings('robovoiceServiceURL')(e.target.value)}
                                type="text"
                                disabled={init.isEnableRobovoice}
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="robovoiceToken"
                                value={edited.robovoiceToken}
                                onChange={(e) => this.onChangeSettings('robovoiceToken')(e.target.value)}
                                type="text"
                                disabled={init.isEnableRobovoice}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                label="Cron время глубины просмотра заказов (мин.)"
                                value={edited.cronCutoffMinutes}
                                onChange={(e) => this.onChangeSettings('cronCutoffMinutes')(e.target.value)}
                                type="number"
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                label="Cron макс. кол-во попыток отправки в ФП"
                                value={edited.cronMaxCountSendFrontpad}
                                onChange={(e) => this.onChangeSettings('cronMaxCountSendFrontpad')(e.target.value)}
                                type="number"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <TimeInput 
                                wrapperClassName="col-md-12"
                                required={true}
                                label="robovoiceOnTimeStart"
                                placeholderText="Начало времени работы"
                                selected={edited.robovoiceOnTimeStart ? moment(edited.robovoiceOnTimeStart).subtract({ hours: utcOffset }).toDate() : null}
                                onChange={this.onChangeTime('robovoiceOnTimeStart')}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-3">
                            <TimeInput 
                                wrapperClassName="col-md-12"
                                required={true}
                                label="robovoiceOnTimeEnd"
                                placeholderText="Окончание времени работы"
                                selected={edited.robovoiceOnTimeEnd ? moment(edited.robovoiceOnTimeEnd).subtract({ hours: utcOffset }).toDate() : null}
                                onChange={this.onChangeTime('robovoiceOnTimeEnd')}
                                className="form-control"
                            />
                        </div>

                        <div className="col-md-6">
                            <Input
                                required={true}
                                label="robovoiceCronInterval, мин"
                                value={edited.robovoiceCronInterval}
                                onChange={(e) => this.onChangeSettings('robovoiceCronInterval')(e.target.value)}
                                type="text"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <div className='form-group'>
                                <label>
                                    Предварительная обработка заказа в PointRobovoice
                                </label>
                                <div>
                                    <Switch 
                                        onChange={(value) => {
                                            this.onChangeSettings('isEnableRobovoiceOrderRedirection')(value)

                                            if (value) {
                                                this.onChangeSettings('isEnableRobovoiceOrderRedirection')(value)
                                            }
                                        }}
                                        checked={edited.isEnableRobovoiceOrderRedirection} 
                                    />
                                </div>
                            </div>                            
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    renderKporogu() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            К-Порогу
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                label="Токен авторизации webhook"
                                value={edited.kporoguWebhookAuthToken}
                                onChange={(e) => this.onChangeSettings('kporoguWebhookAuthToken')(e.target.value)}
                                type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <div className='form-group'>
                                <label>
                                    Включить webhooks
                                </label>
                                <div>
                                    <Switch 
                                        onChange={(value) => this.onChangeSettings('isEnableWebkooks')(value)} 
                                        checked={edited.isEnableWebkooks}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAuth() {
        const { edited } = this.props.settings;

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                            Настройка авторизации
                        </h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <Input 
                        label="Auth-токен"
                        value={edited.token}
                        onChange={(e) => this.onChangeSettings('token')(e.target.value)}
                    />
                    
                    <div className="form-group mb-0 row">
                        <label className="col-xl-12 col-lg-12 col-form-label">Авторизация в приложении</label>
                        <div className="col-lg-12 col-xl-12">
                            <Select
                                value={edited.variantAuths ? edited.variantAuths.split(' ') : undefined}
                                options={auths}
                                getOptionLabel={(item) => `${authsTitle[item]}`}
                                getOptionValue={(item) => item}
                                onChange={this.onChangeAuths('variantAuths')}
                                isMulti
                                isClearable={false}
                                placeholder="Выберите авторизацию..."
                                noOptionsMessage={() => 'Нет авторизаций'}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-0">
                        <label className="col-xl-12 col-lg-12 col-form-label">Авторизация в приложении по умолчанию</label>
                        <div className="col-lg-12 col-xl-12">
                            <Select
                                value={edited.defaultAuth ? [edited.defaultAuth] : undefined}
                                options={auths}
                                getOptionLabel={(item) => `${authsTitle[item]}`}
                                getOptionValue={(item) => item}
                                onChange={this.onChangeAuth('defaultAuth')}
                                isClearable={false}
                                placeholder="Выберите авторизацию..."
                                noOptionsMessage={() => 'Нет авторизаций'}
                            />
                        </div>
                    </div>

                    <div className="kt-separator kt-separator--border-dashed"></div>

                    <div className="form-group mb-0 row">
                        <label className="col-xl-12 col-lg-12 col-form-label">Авторизация на сайте</label>
                        <div className="col-lg-12 col-xl-12">
                            <Select
                                value={edited.variantAuthsSite ? edited.variantAuthsSite.split(' ') : undefined}
                                options={auths}
                                getOptionLabel={(item) => `${authsTitle[item]}`}
                                getOptionValue={(item) => item}
                                onChange={this.onChangeAuths('variantAuthsSite')}
                                isMulti
                                isClearable={false}
                                placeholder="Выберите авторизацию..."
                                noOptionsMessage={() => 'Нет авторизаций'}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-0">
                        <label className="col-xl-12 col-lg-12 col-form-label">Авторизация на сайте по умолчанию</label>
                        <div className="col-lg-12 col-xl-12">
                            <Select
                                value={edited.defaultAuthSite ? [edited.defaultAuthSite] : undefined}
                                options={auths}
                                getOptionLabel={(item) => `${authsTitle[item]}`}
                                getOptionValue={(item) => item}
                                onChange={this.onChangeAuth('defaultAuthSite')}
                                isClearable={false}
                                placeholder="Выберите авторизацию..."
                                noOptionsMessage={() => 'Нет авторизаций'}
                            />
                        </div>
                    </div>
                </div>
            </div>
                        
        );
    }

    renderNotifications() {
        const { edited } = this.props.settings;
        return (
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">Уведомления и обновление заказов</h3>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">SSE-уведомления о новых заказах</label>
                        <div className="col-lg-9 col-xl-6">
                            <Switch checked={edited.sseEnabled} onChange={this.onChangeSettings('sseEnabled')} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">Авто-обновление заказов</label>
                        <div className="col-lg-9 col-xl-6">
                            <Switch checked={edited.autoRefreshEnabled} onChange={this.onChangeSettings('autoRefreshEnabled')} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">Интервал обновления (сек)</label>
                        <div className="col-lg-9 col-xl-6">
                            <Input
                                type="number"
                                isControlledInput
                                value={edited.autoRefreshInterval === '' ? '' : (edited.autoRefreshInterval || 30)}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '') {
                                        this.onChangeSettings('autoRefreshInterval')('');
                                        return;
                                    }

                                    const parsedValue = parseInt(value, 10);
                                    this.onChangeSettings('autoRefreshInterval')(Number.isNaN(parsedValue) ? '' : parsedValue);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }
        
        return (
            <Fragment>
                <Content>
                    { this.renderSubHeader() }
                    <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                        <ErrorContainer field="settings" container={true} hasCloseButton={true}/>
                        <div className="row">
                            <div className="col-xl-3 col-sm-12 col-md-4">
                                {this.renderSale()}
                                {this.renderSettingsFiscal()}
                                {this.renderOrder()}
                                {this.renderUrls()}
                                {this.renderEffectsSetting()}
                                {this.renderCart()}
                                {this.renderVersion()}
                                {this.renderPointsLogs()}
                                {this.renderBlockedPhones()}
                                {this.renderOrderGoodsLogs()}
                                {this.renderIntegration()}
                                {this.renderAuth()}
                                {this.renderValidateOrders()}
                                {this.renderFrontpad()}
                            </div>
                            <div className="col-xl-9 col-sm-12 col-md-8">
                                {this.renderBonus()}
                                {this.renderRestore()}
                                {this.renderCategories()}
                                {this.renderArticlesCash()}
                                {this.renderArticlesCashReport()}
                                {this.renderOtherExpenditures()}
                                {this.renderYumapos()}
                                {this.renderRobovoice()}
                                {this.renderKporogu()}
                                {this.renderNotifications()}
                            </div>
                        </div>
                    </div>
                </Content>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    settings: state.settings,
    loading: state.loaders.settings,
    currentUser: state.user.info,
    loadingFilials: state.loaders.filials,
    loadingTags: state.loaders.tags,
    filials: state.handbook.filials,
    tags: state.handbook.tags,
    articlesCash: state.handbook.articlesCash,
    articlesCashCategories: state.handbook.articlesCashCategories,
    articlesExpenditures: state.handbook.articlesExpenditures,
});

const mapDispatchToProps = {
    fetchArticlesCashCategories: () => fetchArticlesCashCategories(true, true),
    fetchSettings: () => fetchSettings(),
    setEditedSettings: (field, value) => setEditedSettings(field, value),
    updateSettings: (data) => updateSettings(data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    fetchFilials: () => fetchFilials(null, true, true),
    fetchTags: () => fetchTags(true, true),
    fetchArticlesCash: () => fetchArticlesCash(true, true),
    fetchArticlesExpenditures: () => fetchArticlesExpenditures(true, true),
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);